export const SERVICES = [
  {
    id: 1,
    category: 'solar',
    barColor: 'bg-accent-500',
    iconColor: 'text-accent-500',
    iconBg: 'bg-accent-50 dark:bg-accent-900/20',
    titleAr: 'تركيب أنظمة الطاقة الشمسية',
    titleEn: 'Solar System Installation',
    descAr: 'نصمم ونركب أنظمة طاقة شمسية متكاملة للمنازل والمنشآت التجارية والصناعية بأحدث التقنيات وأعلى معايير الجودة.',
    descEn: 'We design and install complete solar PV systems for residential, commercial, and industrial facilities using the latest technology.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
      </svg>
    ),
    features: {
      ar: ['ألواح شمسية معتمدة Tier 1', 'إنفيرتر بكفاءة عالية', 'نظام مراقبة ذكي', 'ضمان 10 سنوات على الأداء'],
      en: ['Tier 1 certified solar panels', 'High-efficiency inverter', 'Smart monitoring system', '10-year performance warranty'],
    },
  },
  {
    id: 2,
    category: 'solar',
    barColor: 'bg-primary-500',
    iconColor: 'text-primary-500',
    iconBg: 'bg-primary-50 dark:bg-primary-900/20',
    titleAr: 'حلول الطاقة المتجددة',
    titleEn: 'Renewable Energy Solutions',
    descAr: 'نقدم استشارات متخصصة وتصميم شامل وتنفيذ متكامل لمشاريع الطاقة المتجددة من أصغر المنازل إلى أكبر المنشآت.',
    descEn: 'Specialized consulting, comprehensive design, and full implementation of renewable energy projects from small homes to large facilities.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    features: {
      ar: ['تدقيق الطاقة والاستشارات', 'تصميم النظام والتخطيط', 'تحليل العائد على الاستثمار', 'إرشادات حوافز الحكومة'],
      en: ['Energy audit & consulting', 'System design & planning', 'ROI analysis', 'Government incentive guidance'],
    },
  },
  {
    id: 3,
    category: 'monitoring',
    barColor: 'bg-primary-600',
    iconColor: 'text-primary-600',
    iconBg: 'bg-primary-50 dark:bg-primary-900/20',
    titleAr: 'أنظمة المراقبة والحماية',
    titleEn: 'Monitoring & Protection Systems',
    descAr: 'أنظمة مراقبة وتحكم وحماية متطورة لأنظمتك الكهربائية والشمسية مع إنذار فوري وكشف أعطال في الوقت الفعلي.',
    descEn: 'Advanced monitoring, control, and protection systems for your electrical and solar installations with real-time fault detection.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    features: {
      ar: ['مراقبة في الوقت الفعلي', 'أنظمة SCADA', 'حماية من الزيادات الكهربائية', 'إنذار وكشف الأعطال'],
      en: ['Real-time monitoring', 'SCADA systems', 'Surge & fault protection', 'Automated alerts'],
    },
  },
  {
    id: 4,
    category: 'electrical',
    barColor: 'bg-yellow-500',
    iconColor: 'text-yellow-600',
    iconBg: 'bg-yellow-50 dark:bg-yellow-900/20',
    titleAr: 'الأعمال الكهربائية',
    titleEn: 'Electrical Works',
    descAr: 'أعمال كهربائية شاملة تشمل التمديدات والألواح والمحولات وشبكات التوزيع لجميع أنواع المنشآت بأعلى معايير السلامة.',
    descEn: 'Comprehensive electrical works including wiring, panels, transformers, and distribution networks for all facility types.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    features: {
      ar: ['توزيع الجهد المتوسط والمنخفض', 'تركيب اللوحات الكهربائية', 'تصحيح معامل القدرة', 'تركيب الكابلات'],
      en: ['MV/LV distribution', 'Panel installation', 'Power factor correction', 'Cable installation'],
    },
  },
  {
    id: 5,
    category: 'maintenance',
    barColor: 'bg-secondary-500',
    iconColor: 'text-secondary-600',
    iconBg: 'bg-secondary-50 dark:bg-secondary-900/20',
    titleAr: 'الصيانة الصناعية',
    titleEn: 'Industrial Maintenance',
    descAr: 'خدمات صيانة وقائية وتصحيحية شاملة للأنظمة الكهربائية والميكانيكية الصناعية لضمان استمرارية التشغيل.',
    descEn: 'Comprehensive preventive and corrective maintenance for industrial electrical and mechanical systems to ensure operational continuity.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    features: {
      ar: ['جدول صيانة وقائية', 'إصلاح طارئ على مدار الساعة', 'فحص المعدات والسلامة', 'تقارير دورية مفصّلة'],
      en: ['Scheduled preventive maintenance', '24/7 emergency repair', 'Equipment safety inspection', 'Detailed periodic reports'],
    },
  },
  {
    id: 6,
    category: 'fire',
    barColor: 'bg-red-500',
    iconColor: 'text-red-600',
    iconBg: 'bg-red-50 dark:bg-red-900/20',
    titleAr: 'أنظمة إنذار الحريق',
    titleEn: 'Fire Alarm Systems',
    descAr: 'تصميم وتركيب أنظمة إنذار حريق متكاملة معتمدة لدى الدفاع المدني، تشمل لوحة التحكم وكواشف الحريق والدخان ونقاط الإطلاق اليدوية وأجهزة التنبيه الصوتية والضوئية.',
    descEn: 'Design and installation of complete, Civil-Defense-compliant fire alarm systems — control panels, smoke and heat detectors, manual call points, and audible/visual alarms.',
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M17.657 18.657A8 8 0 016.343 7.343S7 9 9 10c0-2 .5-5 2.986-7C14 5 16.09 5.777 17.657 7.343A7.975 7.975 0 0120 13a7.975 7.975 0 01-2.343 5.657z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M9.879 16.121A3 3 0 1012.015 11L11 14H9c0 .768.293 1.536.879 2.121z" />
      </svg>
    ),
    features: {
      ar: ['لوحة تحكم رئيسية معتمدة', 'كواشف حريق ودخان', 'نقاط إطلاق يدوية', 'أنظمة تنبيه صوتية وضوئية'],
      en: ['Certified main control panel', 'Smoke & heat detectors', 'Manual call points', 'Audible & visual alarms'],
    },
  },
  {
    id: 7,
    category: 'environment',
    barColor: 'bg-secondary-500',
    iconColor: 'text-secondary-600',
    iconBg: 'bg-secondary-50 dark:bg-secondary-900/20',
    titleAr: 'إعادة التدوير وإدارة النفايات',
    titleEn: 'Recycling & Waste Management',
    descAr: 'نقدم حلولاً لفرز وجمع النفايات من المصدر وإعادة التدوير، بالشراكة مع بلدية معان الكبرى، سعياً للحد من التلوث البيئي وتعزيز الاستدامة.',
    descEn: "We provide source-sorting, collection, and recycling solutions in partnership with Greater Ma'an Municipality, aiming to reduce environmental pollution and promote sustainability.",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
          d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
      </svg>
    ),
    features: {
      ar: ['فرز النفايات من المصدر', 'جمع الكرتون والمواد القابلة لإعادة التدوير', 'شراكة مع بلدية معان الكبرى', 'التوعية البيئية المجتمعية'],
      en: ['Source waste sorting', 'Cardboard & recyclables collection', "Partnership with Greater Ma'an Municipality", 'Community environmental awareness'],
    },
  },
];

export const CATEGORIES = [
  { id: 'all',         ar: 'جميع الخدمات', en: 'All Services' },
  { id: 'solar',       ar: 'طاقة شمسية',   en: 'Solar Energy' },
  { id: 'monitoring',  ar: 'مراقبة وحماية', en: 'Monitoring' },
  { id: 'electrical',  ar: 'كهربائي',       en: 'Electrical' },
  { id: 'maintenance', ar: 'صيانة',         en: 'Maintenance' },
  { id: 'fire',        ar: 'إنذار الحريق',   en: 'Fire Alarm' },
  { id: 'environment', ar: 'بيئة واستدامة', en: 'Environment' },
];
